"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconNameForSuggestion = exports.mapAutocompleteObjectToSuggestion = exports.mapAgencyToIconName = void 0;
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const fdr_agency_map_search_types_1 = require("./fdr-agency-map-search.types");
function mapAgencyToIconName(agency) {
    switch (agency.brand) {
        case supergraph_api_1.FdrAgencyBrand.GlobusReisen:
            return 'globusreisen';
        case supergraph_api_1.FdrAgencyBrand.Travelhouse:
            return 'travelhouse';
        case supergraph_api_1.FdrAgencyBrand.Hotelplan:
            return 'hotelplanpin';
        case supergraph_api_1.FdrAgencyBrand.Tpt:
            return 'tpt';
        case supergraph_api_1.FdrAgencyBrand.Sv:
            return 'sv';
    }
    return '';
}
exports.mapAgencyToIconName = mapAgencyToIconName;
function mapAutocompleteObjectToSuggestion(obj, t) {
    var _a;
    if ('brand' in obj) {
        return {
            id: obj.id,
            type: fdr_agency_map_search_types_1.AgenciesSuggestionType.AGENCY,
            brand: obj.brand,
            name: [
                obj.name,
                (_a = obj.address) === null || _a === void 0 ? void 0 : _a.street,
                `${obj.address.zip} ${obj.address.city}`,
            ]
                .filter(Boolean)
                .join(', '),
            url: obj.webMeta.link,
        };
    }
    return {
        type: fdr_agency_map_search_types_1.AgenciesSuggestionType.MAP_OBJECT,
        name: obj.locationType === supergraph_api_1.FdrAgencyGeoLocationType.Region
            ? t('agency:search.regionName', { name: obj.name })
            : obj.name,
        coordinates: obj.coordinates,
        zoom: obj.zoom,
    };
}
exports.mapAutocompleteObjectToSuggestion = mapAutocompleteObjectToSuggestion;
function getIconNameForSuggestion(item) {
    if (item.type === fdr_agency_map_search_types_1.AgenciesSuggestionType.AGENCY) {
        return mapAgencyToIconName(item);
    }
    else if (item.type === fdr_agency_map_search_types_1.AgenciesSuggestionType.MAP_OBJECT) {
        return 'planet';
    }
    return '';
}
exports.getIconNameForSuggestion = getIconNameForSuggestion;
//# sourceMappingURL=fdr-agency-map-search.utils.js.map